<template>
  <v-app :dark="dark" :class="[dark ? 'app-dark' : '', { 'has-trial-banner': trialDaysRemaining !== null }]">
    <Anuncio30s ref="anuncio30" />
    <div v-if="user" key="authenticated" :style="'padding: 0; margin: 0;'">
      <div v-if="trialDaysRemaining !== null" class="trial-banner">
        <span><strong>{{ strings[idioma].teste_gratis }}:</strong> {{ trialDaysRemaining === 0 ? strings[idioma].teste_termina_hoje : trialDaysRemaining === 1 ? strings[idioma].teste_termina_amanha : strings[idioma].teste_termina_em.replace('{0}', trialDaysRemaining) }}</span>
        <router-link to="/seja-premium">{{ strings[idioma].teste_assinar_agora }}</router-link>
      </div>
      <v-hover v-if="!appMobileMode">
        <core-toolbar :style="'z-index: 10'" />
      </v-hover>
      <NavMobile v-if="!inputValue && !appMobileMode"></NavMobile>

      <core-drawer v-if="!appMobileMode" style="z-index: 20" />

      <core-view
        :style="appMobileMode ? '' : inputValue ? 'margin-top: 48px; padding-bottom: 48px;' : 'margin-top: 48px; margin-bottom: 120px'" />

      <div v-if="mostraFecharDialog && exibeAnuncio && anuncio && anuncio.id !== null">
        <AnuncioBanner />
      </div>

    </div>
    <div v-else key="guest">
      <core-toolbar-login />
      <core-background-login :gradientBG="gradientBG" />
      <core-view v-if="pageFree" class="no-padding" />
    </div>

    <footer>

      <cookie-law v-show="$vuetify.breakpoint.width >= 800" style="padding: 20px; height: 70px" theme="dark-lime">
        <div slot-scope="props" class="cookies Cookie" style="padding: 20px;">
          <div class="Cookie__content">
            Este sistema utiliza cookies para gerar informações mais relevantes aos usuários (<a
              :href="baseSiteURL + '/politica-de-privacidade'" target="_blank" class="green--text bold--text">Veja
              Mais</a>)

          </div>
          <div class="Cookie__buttons">
            <button class="Cookie__button" @click="props.accept"><span>Aceito</span></button>
            <button flat @click="props.close"><span>Fechar</span></button>
          </div>
        </div>

      </cookie-law>
      <cookie-law v-show="$vuetify.breakpoint.width < 800" theme="dark-lime">
        <div slot="message">
          Este sistema utiliza cookies para gerar informações mais relevantes aos usuários (<a
            :href="baseSiteURL + '/politica-de-privacidade'" target="_blank" class="green--text bold--text">Veja
            Mais</a>)
        </div>
      </cookie-law>

    </footer>

    <HotJar />
  </v-app>
</template>
<style>
.v-stepper__step--active {
  border-bottom: 3px solid blue;
  opacity: 0.9 !important;
  background: rgba(226, 226, 226, 0.5) !important;
}
</style>

<script>
import _ from 'lodash';
import moment from 'moment';
import { mapState, mapMutations } from 'vuex';
import CookieLaw from 'vue-cookie-law'
import HotJar from './views/components/HotJar'
import Banner from './views/components/Banner'
import Video from './views/components/Video'
import { ANUNCIO, PERMITE_ACESSO_GRATUITO } from './utils/types'
import AnuncioBanner from './views/components/AnuncioBanner'
import NavMobile from './views/components/NavMobile'
import { registerVisit } from './utils/visits';
import { verificaCadastroIncompleto } from './utils/user';
import Anuncio30s from './views/components/Anuncio30s.vue';
import { mostraAnuncio30s } from './utils/utils';
export default {
  components: { CookieLaw, HotJar, Banner, Video, AnuncioBanner, NavMobile, Anuncio30s },
  data: () => ({
    appMobileMode: false,
    tokenMobile: null,
    logado: false,
    token: null,
    gradientBG: process.env.VUE_APP_BG ? process.env.VUE_APP_BG : 'to top right, rgba(100,115,201,.40), rgba(25,32,72,.7)',
    logo: 'img/brcorte-logo.png',
    url: '/',
    baseSiteURL: process.env.VUE_APP_BRCORTE_SITE || 'https://brcorte.com.br/site',
    params: null,
    exibeAnuncio: false,
    adsDialog: true,
    adsBanner: true,
    mostraFecharDialog: false,
    permiteAcessoGratuito: true,
    anuncio: {
      id: null,
      titulo: 'Assine o plano pecuarista',
      youtube_src: 'CHJtDyWAuMg',
      img_src: null,
      link: '#',
      idioma: 0,
      tempo_pular: 30
    }
  }),
  computed: {
    ...mapState('app', ['step', 'user', 'trava_back', 'curr_version', 'strings', 'idioma', 'dark']),
    trialDaysRemaining() {
      const plano = this.user && this.user.plano
      if (!plano || parseInt(plano.teste) !== 1 || parseInt(plano.revogado) === 1 || this.user.possuiPlanoPagoAtivo || !plano.data_final) return null
      const fim = moment(plano.data_final)
      if (!fim.isValid() || fim.isBefore(moment(), 'day')) return null
      return fim.startOf('day').diff(moment().startOf('day'), 'days')
    },
    isMobile() {
      return (this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.md)
    },
    pageFree() {
      return _.get(this.$route, 'matched[0].props.default.free')
    },
    inputValue: {
      get() {
        if (this.$route.path === '/dashboard' && this.$vuetify.breakpoint.width > 991) return true
        return this.$store.state.app.drawer
      },
      set(val) {
        this.setDrawer(val)
      }
    }
  },
  watch: {
    async '$route'(val) {
      if (this.appMobileMode) return
      if (!this.logado || !this.user || val.path === '/login') return
      if (!await this.verificaToken() || !this.user) return
      this.registerVisit(val.path)
      const cadastroIncompleto = !_.get(this.user, 'IsRegistrationComplete', true) || verificaCadastroIncompleto(this.user)
      if (val.path !== '/user' && val.path !== '/login' && cadastroIncompleto) {
        this.$router.push('user')
        alert(this.strings[this.idioma].msg_bloqueio_funcionalidade)
      }
    }
  },
  mounted() {
    if (!this.logado || this.appMobileMode) return
    this.exibeAnuncio = this.getAcessoModulo({ user: this.user, modulo: ANUNCIO })
    if (this.exibeAnuncio) {
      mostraAnuncio30s()
    }
  },
  async created() {
    document.querySelector('html').classList.add('no-overflow')
    this.$vuetify.lang.current = 'pt'
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    const isMobile = urlParams.get('mobileaccess') === '1';
    this.appMobileMode = isMobile;
    this.tokenMobile = token;
    this.token = localStorage.getItem('user-token')
    this.logado = !!this.token;
    this.applyUserByLocalStorage();
    await this.autoLogin();
    this.locationJob();
    await this.afterLoading();
    if (!this.user) return;
    // Redireciona de forma mais segura
    this.safeRedirect();
    this.adsDialog = true;
  },
  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer', 'toggleDark', 'setDark']),
    applyUserByLocalStorage() {
      try {
        const user = JSON.parse(localStorage.getItem('user'));
        this.$store.commit('setUser', user);
        if (this.user !== null) {
          if (this.user.empresa_vinculada && this.user.empresa_vinculada[0]) {
            this.$store.commit('setEmpresa', this.user.empresa_vinculada)
          } else {
            this.$store.commit('setEmpresa', JSON.parse(localStorage.getItem('empresa')))
          }
        }
        if (localStorage.getItem('dark')) {
          this.setDark(JSON.parse(localStorage.getItem('dark')))
        }
        if (localStorage.getItem('idioma')) {
          this.$store.commit('setIdioma', parseInt(localStorage.getItem('idioma')))
        } else {
          var userLang = window.navigator.language || window.navigator.userLanguage
          localStorage.setItem('idioma', userLang.startsWith('pt') ? 0 : 1)
          this.$store.commit('setIdioma', parseInt(localStorage.getItem('idioma')))
        }
      } catch (e) {
        this.$store.commit('setUser', null);
      }
    },
    async autoLogin() {
      // Verifica se está no modo mobile e tem token
      if (!this.appMobileMode || !this.tokenMobile) return;

      // Se já estiver logado, não faz nada
      if (this.logado) return;

      // Verifica se o token é válido antes de tentar login
      if (!this.tokenMobile || this.tokenMobile.length < 10) {
        console.error('Token inválido para autoLogin');
        return;
      }

      // Remove o setTimeout e faz login imediatamente
      await this.executeMobileLogin();

    },
    async executeMobileLogin() {
      try {
        const dados = {
          email: 'usuario_comum@brcorte.com',
          password: '1234',
          loginByToken: true,
          accessToken: this.tokenMobile
        };

        const response = await this.axios.post('auth/appLogin', dados);

        // Armazena os dados de autenticação
        localStorage.setItem('user-token', response.data.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.data.user));
        localStorage.setItem('sessoes', JSON.stringify(response.data.data.sessoes));

        // Configura o axios
        this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.data.token;
        this.$store.commit('setUser', response.data.data.user);
        this.logado = true;
        const currentPath = this.$route.path;
        // Redireciona de forma mais segura
        this.safeRedirect(currentPath);

      } catch (error) {
        console.error('Erro no autoLogin mobile:', error);
        // Remove o token inválido para evitar loops
        localStorage.removeItem('user-token');
        this.tokenMobile = null;
      }
    },

    safeRedirect(defaultPath = null) {
      const sessionLastPage = sessionStorage.getItem('lastPage');
      if (!sessionLastPage && !defaultPath) return;
      // Verifica se já está na página desejada para evitar reload desnecessário
      const lastPage = sessionLastPage || defaultPath;
      const currentPath = this.$route.path;

      if (currentPath !== lastPage) {
        // Usa o router do Vue em vez de window.location
        this.$router.push(lastPage).catch(() => { });
      }

      sessionStorage.removeItem('lastPage');
    },
    locationJob() {
      const success = (position) => {
        const latitude = position.coords.latitude
        const longitude = position.coords.longitude
        const acuracia = position.coords.accuracy
        localStorage.setItem('lat', latitude)
        localStorage.setItem('lon', longitude)
        localStorage.setItem('acc', acuracia)
      };

      const error = (err) => {

        try {
          this.axios.post('auth/meuIP', {}).then((r) => {
            let ip = localStorage.getItem('ip')
            let meuIP = r.data.data
            if (ip && meuIP === ip) return
            localStorage.setItem('ip', meuIP)
            navigator.__defineGetter__('userAgent', function () {
              return "keycdn-tools:https://www.brcorte.com.br/"
            });
            fetch('https://tools.keycdn.com/geo.json?host=' + meuIP, {
              method: 'GET'
            }).then(res => res.body.json()).then(res => {
              success({
                coords: {
                  ...res.data.geo
                }
              })
            })
          })
        } catch (err) {
          if (!this.user || !(this.user.pecuarista || this.user.premium || this.user.consultor || this.user.vinculado || this.user.gestor)) {
            localStorage.removeItem('ip')
            alert('O acesso a sua localização é importante para melhorias no BR-Corte 5.0!')
          }

          navigator.geolocation.getCurrentPosition(success, null)
        }

      };

      navigator.geolocation.getCurrentPosition(success, error)
    },
    deslogar() {
      this.$store.commit('setUser', null)
      localStorage.removeItem('user')
      localStorage.removeItem('user-token')
      this.$store.commit('resetStates')
      if (next) {
        next({
          path: '/login'
        })
      } else window.location.replace('/login')
    },
    async verificaToken(next = null) {
      const token = localStorage.getItem('user-token')
      if (!token) return false
      const clientTokenFirebase = localStorage.getItem('clientToken') ? localStorage.getItem('clientToken') : null
      const params = {
        lat: localStorage.getItem('lat'),
        lon: localStorage.getItem('lon'),
        clientTokenFirebase,
        token
      }
      const userAntigo = Object.assign({}, this.user)
      try {
        const res = await this.axios.post('verificaToken', params)
        const userNovo = _.get(res, 'data.data.user', null);
        const acessoBloqueado = parseInt(_.get(userNovo, 'liberado')) === 0
        const userDeleted = parseInt(_.get(userNovo, 'EXCLUIDO')) === 1
        if (userNovo === null) return false
        if (acessoBloqueado || userDeleted) {
          this.deslogar(next);
          acessoBloqueado && alert(this.strings[this.idioma].msg_usuario_em_analise)
          userDeleted && alert(this.strings[this.idioma].conta_inativa_msg)
          return false
        }

        localStorage.setItem('user', JSON.stringify(userNovo))
        this.$store.commit('setUser', userNovo)
        if (userAntigo && userAntigo.area_universitaria !== undefined && _.get(res, 'data.data.user.area_universitaria', null) !== _.get(userAntigo, 'area_universitaria', null)) {
          window.location.reload()
        }

      } catch (e) {
        const statusCode = _.get(e, 'response.status', null)
        if ([500, 401].includes(statusCode)) {
          const msg = _.get(e, 'response.data.errors.message', '');
          if (String(msg).trim() === 'Unauthenticated.') {
            this.deslogar(next);
          }
        }
        return false
      }
      return true

    },
    async logout() {
      const desloga = () => {
        this.logado = false
        this.axios.defaults.headers.common['Authorization'] = null
        this.$limpaLocalStorage()
        localStorage.removeItem('user')
        localStorage.removeItem('user-token')
        localStorage.removeItem('lastUpdate')
        localStorage.removeItem('alimentos')
        localStorage.removeItem('empresa')
        localStorage.removeItem('tipos')
        localStorage.removeItem('usa_dieta')
        localStorage.removeItem('usa_predicao')
        localStorage.removeItem('usa_tabela')
        localStorage.removeItem('acesso')
        sessionStorage.removeItem('empresaAdm')
        this.$store.commit('resetStates')
        if (!this.pageFree) window.location.replace('/login')
      }
      let token = localStorage.getItem('user-token')
      return this.axios.post('auth/logout', { token: token }).finally(() => {
        desloga()
      });
    },
    async anuncioClique(anuncio) {
      try {
        let au = await this.axios.post('anuncios/registerClique', { id: anuncio.id })
        let anuncioUser = au.data.data
        if (!anuncioUser) throw new Exception('Erro de clique')
        let win = window.open(anuncio.link, '_blank')
        if (!win) window.location.href = anuncio.link

      } catch (e) {
        window.location.href = anuncio.link
      }

    },
    async afterLoading() {
      const isPersistentLogin = parseInt(localStorage.getItem('rememberLogin')) !== 1;
      if (isPersistentLogin) {
        const usertoken = sessionStorage.getItem('user-token');
        if (!usertoken && !this.pageFree && !this.appMobileMode) {
          await this.logout().catch(() => {})
          return;
        }
      }
      this.adsDialog = true
      this.exibeAnuncio = this.getAcessoModulo({ user: this.user, modulo: ANUNCIO })
      this.permiteAcessoGratuito = this.getAcessoModulo({ user: this.user, modulo: PERMITE_ACESSO_GRATUITO })
      this.locationJob()
      if (localStorage.getItem('dark')) {
        this.setDark(JSON.parse(localStorage.getItem('dark')))
      }


      if (this.exibeAnuncio) {
        if (![undefined, null, {}].includes(this.user) && !this.permiteAcessoGratuito && process.env.VUE_APP_ACESSO_GRATUITO && parseInt(process.env.VUE_APP_ACESSO_GRATUITO) === 0) {
          alert("Você não tem créditos suficientes! Entre em contato com o seu consultor.")
          this.deslogar()
        }
        const adblockLocal = localStorage.getItem('adblock')
        const usaAdBlock = adblockLocal && adblockLocal === 'true'
        if (usaAdBlock) {
          alert(this.strings[this.idioma].adblock_ativo)
          this.deslogar()
        }
        if (Math.random() > 0.7) {
          this.adsDialog = true
          let anuncio = await this.axios.post('anuncios/get')
          console.log({ anuncio })
          this.anuncio = anuncio && anuncio.data && anuncio.data.data && anuncio.data.data.length ? anuncio.data.data : this.anuncio
          setTimeout(() => {
            this.mostraFecharDialog = true
          }, this.anuncio.tempo_pular * 1000)

        } else {
          this.adsDialog = false
        }

        document.addEventListener('contextmenu', event => event.preventDefault())
        document.addEventListener('selectstart', event => event.preventDefault())
        /** TO DISABLE SCREEN CAPTURE **/
        document.addEventListener('keyup', (e) => {
          if (e.key == 'PrintScreen') {
            navigator.clipboard.writeText('')
            alert('Screenshots disabled!')
          }
        })

        /** TO DISABLE PRINTS WHIT CTRL+P **/
        document.addEventListener('keydown', (e) => {
          if (e.ctrlKey && e.key == 'p') {
            alert('This section is not allowed to print or export to PDF')
            e.cancelBubble = true
            e.preventDefault()
            e.stopImmediatePropagation()
          }
        })
      }
    },
    async registerVisit(...params) {
      try {
        await registerVisit(...params);
      } catch (e) { }
    }
  }
}
</script>

<style lang="scss">
@use 'styles/index.scss';

.trial-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 32px;
  z-index: 30;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 4px 12px;
  background: #eaf5e8;
  color: #174d38;
  font-size: 13px;
  text-align: center;
}

.trial-banner a {
  color: #174d38;
  font-weight: bold;
  text-decoration: underline;
}

.has-trial-banner #core-toolbar {
  top: 32px;
}

.has-trial-banner #app-drawer {
  top: 32px;
  height: calc(100% - 32px) !important;
}

.has-trial-banner #core-view {
  margin-top: 32px;
}

@media (max-width: 600px) {
  .trial-banner {
    height: 48px;
    font-size: 12px;
  }

  .has-trial-banner #core-toolbar {
    top: 48px;
  }

  .has-trial-banner #app-drawer {
    top: 48px;
    height: calc(100% - 48px) !important;
  }

  .has-trial-banner #core-view {
    margin-top: 48px;
  }
}

/* Remove in 1.2 */
.v-datatable thead th.column.sortable i {
  vertical-align: unset;
}

.no-padding #core-view {
  padding: 0px;
}
</style>
